export default "__VITE_ASSET__OdVYk10j__"